var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.38531C10.7225 5.38531 11.8025 5.67781 12.68 6.06031C13.49 6.42031 14 7.23031 14 8.10781V9.32281H5V8.11531C5 7.23031 5.51 6.42031 6.32 6.06781C7.1975 5.67781 8.2775 5.38531 9.5 5.38531ZM3.5 5.57281C4.325 5.57281 5 4.89781 5 4.07281C5 3.24781 4.325 2.57281 3.5 2.57281C2.675 2.57281 2 3.24781 2 4.07281C2 4.89781 2.675 5.57281 3.5 5.57281ZM4.3475 6.39782C4.07 6.35282 3.7925 6.32281 3.5 6.32281C2.7575 6.32281 2.0525 6.48031 1.415 6.75781C0.86 6.99781 0.5 7.53782 0.5 8.14532V9.32281H3.875V8.11531C3.875 7.49281 4.0475 6.90782 4.3475 6.39782ZM15.5 5.57281C16.325 5.57281 17 4.89781 17 4.07281C17 3.24781 16.325 2.57281 15.5 2.57281C14.675 2.57281 14 3.24781 14 4.07281C14 4.89781 14.675 5.57281 15.5 5.57281ZM18.5 8.14532C18.5 7.53782 18.14 6.99781 17.585 6.75781C16.9475 6.48031 16.2425 6.32281 15.5 6.32281C15.2075 6.32281 14.93 6.35282 14.6525 6.39782C14.9525 6.90782 15.125 7.49281 15.125 8.11531V9.32281H18.5V8.14532ZM9.5 0.322815C10.745 0.322815 11.75 1.32781 11.75 2.57281C11.75 3.81781 10.745 4.82281 9.5 4.82281C8.255 4.82281 7.25 3.81781 7.25 2.57281C7.25 1.32781 8.255 0.322815 9.5 0.322815Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.934bda7987f73bb17f3227249bdd7238.svg";
export { ForwardRef as ReactComponent };